module.exports = __webpack_public_path__ + "static/design-preview-4b0f3a22c118664faa66f08a476c4b1d.jpg";